<div class="flex-container">
  <app-avatar-icon></app-avatar-icon>
  {{ player.name }}
  <!-- <app-membership-icon [isTeamMember]="player.teamMember" (teamSelectionChange)="onTeamSelectionChanged($event)">
    </app-membership-icon> -->
</div>
